<template>
	<v-card>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 260px;" class="mr-1">
								<v-select :items="selectCourseList" v-model="query.courseId" item-text="courseName"
									item-value="id" label="课程" dense outlined clearable></v-select>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-text-field clearable dense label="学号" outlined v-model="query.studentNo">
								</v-text-field>
							</div>
							<!-- <div style="width: 200px;" class="mr-1">
								<v-text-field clearable dense label="学员姓名" outlined v-model="query.studentName">
								</v-text-field>
							</div> -->
							<studentSearchBox @inputValue="setInputValue"></studentSearchBox>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								    transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									 transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
							
						</v-col>
						
					</v-row>
					<v-divider></v-divider>
				</template>
				
				<template v-slot:item.inOut="{item}">
					<span v-if="item.inOut=='1'" style="color:red">增加</span>
					<span v-if="item.inOut=='2'">减少</span>
				</template>
				<template v-slot:item.amount="{item}">
					<span v-if="item.inOut=='1'" style="color:red">+{{item.amount}}</span>
					<span v-if="item.inOut=='2'">-{{item.amount}}</span>
				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

	</v-card>
</template>

<script>
	import studentSearchBox from "../../../components/student_search_box.vue"
	import utils from "../../../config/utils"
	export default {
		name: "account-journal-list",
		components:{studentSearchBox},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				data: {
					total: 0,
					headers: [
						{
							text: '课程名称',
							value: 'courseName',
							sortable: false
						},
						{
							text: '学号',
							value: 'studentNo',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '进/出',
							value: 'inOut',
							sortable: false
						},
						{
							text: '业务类型',
							value: 'bizType',
							sortable: false
						},
						{
							text: '业务前课时',
							value: 'lastAmount',
							sortable: false
						},
						{
							text: '本次课时',
							value: 'amount',
							sortable: false
						},
						{
							text: '业务后课时',
							value: 'balanceAmount',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '备注',
							align: 'left',
							value: 'memo',
							sortable: false
						},
					],
					list: [],
				},
				selectCourseList:[],
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					courseId: "",
					studentNo:"",
					studentName:""
				},
			}
		},
		created() {
	
			this.getCourseListForSelect();
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			setInputValue(value){
				// 搜索框输入的值
				this.query.studentName = value;
			},
			queryShopChanged(){
				let shopId = this.query.shopId;
				this.getCourseListForSelect(shopId);
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;
				
				const shopId = utils.getCurrentShopId();

				let url = `/financial/student/account/journal/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				
				if (this.query.courseId) {
					url += "&courseId=" + this.query.courseId;
				}
				if (this.query.studentNo) {
					url += "&studentNo=" + this.query.studentNo;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			inOutName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "增加";
				} else if (state === "2") {
					stName = "减少";
				}
				return stName;
			},
			inOutColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "error";
				}
				return color;
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			
			getCourseListForSelect(){
				const shopId = utils.getCurrentShopId();
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/course/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},

		}
	}
</script>

<style>
</style>
